/**
 * Telegram SDK loading utilities
 */

import { shouldLoadTelegramSDK } from './detectors';

/**
 * Dynamically load Telegram Web App SDK
 * Returns a promise that resolves when SDK is loaded
 */
export async function loadTelegramSDK(): Promise<boolean> {
  if (typeof window === 'undefined') {
    return false;
  }

  // Check if SDK already loaded
  if ((window as any).Telegram?.WebApp) {
    return true;
  }

  // Only load if we detect Telegram environment
  if (!shouldLoadTelegramSDK()) {
    return false;
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-web-app.js';
    script.async = true;

    script.onload = () => {
      console.log('Telegram SDK loaded successfully');
      resolve(true);
    };

    script.onerror = () => {
      console.error('Failed to load Telegram SDK');
      resolve(false);
    };

    document.head.appendChild(script);
  });
}
